"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { LOGOS } from "@/constants/home.constants";
import { useCounterAnimation } from "./useCounterAnimation";
import { useFaqAccordion } from "./useFaqAccordion";
import { useRoadmapAnimation } from "./useRoadmapAnimation";
import { useTestimonialCarousel } from "./useTestimonialCarousel";
export function useHomePageInteractions() {
  const $ = _c(10);
  const {
    counterValues
  } = useCounterAnimation();
  const {
    activeStep
  } = useRoadmapAnimation();
  const {
    active: activeTestimonial
  } = useTestimonialCarousel();
  const {
    openIndex: openFaq,
    toggle
  } = useFaqAccordion(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...LOGOS, ...LOGOS];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const repeatedLogos = t0;
  let t1;
  if ($[1] !== openFaq || $[2] !== toggle) {
    t1 = fn => toggle(fn(openFaq));
    $[1] = openFaq;
    $[2] = toggle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeStep || $[5] !== activeTestimonial || $[6] !== counterValues || $[7] !== openFaq || $[8] !== t1) {
    t2 = {
      activeStep,
      activeTestimonial,
      counterValues,
      openFaq,
      repeatedLogos,
      setOpenFaq: t1
    };
    $[4] = activeStep;
    $[5] = activeTestimonial;
    $[6] = counterValues;
    $[7] = openFaq;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}